// PROOF — Drops registry.
// Each drop describes a Field release: hero, manifesto, launch date, passcode
// (for gated early access) and which products from `src/data/products.js`
// belong to it (matched by `product.drop`).

// Use an offset-from-now for the upcoming drop so the countdown stays alive
// across previews. Replace with fixed ISO dates when wiring to a CMS.
const daysFromNow = (n) => {
    const d = new Date();
    d.setDate(d.getDate() + n);
    d.setHours(20, 0, 0, 0);
    return d.toISOString();
};

const daysAgo = (n) => {
    const d = new Date();
    d.setDate(d.getDate() - n);
    d.setHours(20, 0, 0, 0);
    return d.toISOString();
};

export const DROPS = [
    {
        slug: "field-002",
        n: "002",
        title: "Field 002",
        eyebrow: "Pre-launch · Passcode required",
        tagline: "Boiled wool. Half-canvas. The atelier's second voice.",
        manifesto:
            "Field 002 was cut over the winter. Heavier hand, fewer pieces, a single fabric thesis: how does a garment age when nothing about it shouts?",
        launchAt: daysFromNow(14),
        passcode: "FIELD002",
        productDropTag: "Field 002 · Pre-order",
        // Visual treatment
        heroVideo: "/assets/yk/footer-video.webm",
        heroPoster: "/assets/yk/products/p4.png",
        gallery: [
            "/assets/yk/products/p4.png",
            "/assets/yk/products/p2.png",
            "/assets/yk/products/p5.png",
        ],
        bgTone: "#e8e7e1",
    },
    {
        slug: "field-001",
        n: "001",
        title: "Field 001",
        eyebrow: "Live · Open access",
        tagline: "Eight artifacts. One unit of intent.",
        manifesto:
            "The starting point. Eleven artifacts in heavy cotton, raw denim and boiled wool — cut, sewn and finished slowly in Warsaw. The collection that established the protocol.",
        launchAt: daysAgo(60),
        passcode: null,
        productDropTag: "Field 001",
        heroVideo: "/assets/yk/footer-video.webm",
        heroPoster: "/assets/yk/products/p1.png",
        gallery: [
            "/assets/yk/products/p1.png",
            "/assets/yk/products/p2.png",
            "/assets/yk/products/p3.png",
            "/assets/yk/products/p4.png",
            "/assets/yk/products/p5.png",
            "/assets/yk/products/p7.png",
        ],
        bgTone: "#d2d1cb",
    },
];

export const getDropBySlug = (slug) => DROPS.find((d) => d.slug === slug) || null;

export const isLaunched = (drop) => {
    if (!drop) return false;
    return new Date(drop.launchAt).getTime() <= Date.now();
};
